import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOpenbsdComponent } from './simple-icons-openbsd.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOpenbsdComponent ],
    exports:      [ SimpleIconsOpenbsdComponent ],
    bootstrap:    []
})
export class SimpleIconsOpenbsdModule {}
